//
import fieldsBranch from './fieldsBranch'
export default [
    {
        field: 'name',
        type: 'text',
        vuetifyProps: {
            label: 'Nombre',
        },
        rules: ['required'],
    },
    {
        field: 'alias_name',
        type: 'text',
        vuetifyProps: {
            label: 'Alias',
        },
        rules: ['required'],
    },
    {
        field: 'description',
        type: 'text',
        vuetifyProps: {
            label: 'Descripción',
        },
    },
    {
        field: 'internal_code',
        type: 'text',
        vuetifyProps: {
            label: 'Código interno',
        },
        rules: ['required'],
    },
    {
        field: 'wh_family_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Familia',
        },
        options: {
            data: [],
            text: 'family',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'wh_subfamily_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Subfamilia',
            'no-data-text': '¡ Subfamilias No encontradas!',
        },
        options: {
            data: [],
            text: 'subfamily',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'warranty_days',
        type: 'text',
        vuetifyProps: {
            label: 'Garantía (días)',
            mask: '####',
        },
        rules: ['required'],
    },
    {
        field: 'tags',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Etiquetas',
            multiple: true,
            chips: true,
            'deletable-chips': true,
        },
        options: {
            data: [],
            text: 'tag',
            value: 'id',
        },
    },
    {
        field: 'wh_unit_of_measurement_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Unidad de medida',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'uom_quantity',
        type: 'text',
        vuetifyProps: {
            label: 'Cantidad minima unidad medida',
            mask: '####',
        },
        rules: ['required'],
    },
    ...fieldsBranch,
    {
        field: 'is_repackaged',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Envasado',
        },
        value: false,
    },
    {
        field: 'is_tax_free',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto libre de impuesto',
        },
        value: false,
    },
    {
        field: 'is_salable',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Vendible',
            'false-value': false,
        },
        value: false,
    },
    {
        field: 'is_consumable',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Consumo interno',
            'false-value': false,
        },
        value: false,
    },
    {
        field: 'is_seasonal',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto temporada',
            'false-value': false,
        },
        value: false,
    },
    {
        field: 'is_inventoriable',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Inventariable',
            'false-value': false,
        },
        value: false,
    },
    {
        field: 'have_decimal_quantity',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Cantidad decimal',
        },
        value: false,
    },
]
